<template>
    <layout>
        <div>

            <div class="mb-2">
                <info-collapse-area>
                    <template v-slot:title>
                        <div class="w-100 d-flex flex-column flex-md-row justify-content-md-between">
                            <div class="mt-1 mt-md-0 mb-1 mb-md-0 fs-16">
                                {{ getObjectValue(formData, 'name') }} {{ getObjectValue(formData, 'surname') }}
                            </div>
                            <!--
                            <div class="mb-1 mb-md-0 mr-0 mr-md-4">
                                <template v-if="application.result">
                                    <b-badge
                                        :variant="(application.result == 'placed' ? 'success' : 'danger') + ' text-uppercase'">
                                        {{ resultStatusText }}
                                    </b-badge>
                                </template>
                                <template v-else>
                                    {{ applicationStatusMessage }}
                                </template>
                            </div>
                            -->
                        </div>
                    </template>
                    <template v-slot:detail>
                        {{ getObjectValue(formData, 'name') }}
                        {{ getObjectValue(formData, 'surname') }}
                    </template>
                </info-collapse-area>
            </div>

            <div class="border rounded-sm pt-4 pl-4 pr-4 bg-white">
                <b-tabs content-class="py-5 position-relative" class="line-tabs" fill>
                    <div class="tabs-bottom-line"></div>
                    <b-tab :active="tabIndex===0" @click="tabIndex = 0">
                        <template #title>
                            {{ $t('personal_info') }}
                        </template>
                        <PersonalInformation v-if="tabIndex===0" @goNextTab="nextTab($event)"/>
                    </b-tab>
                    <b-tab :active="tabIndex===1"  @click="tabIndex = 1">
                        <template #title>
                            {{ $t('certificate') }}
                        </template>
                        <Certificate v-if="tabIndex ===1"/>
                    </b-tab>
                </b-tabs>
            </div>
        </div>
    </layout>
</template>
<script>
import Layout from '@/modules/ulmerCertificatesApplicationForm/layout/Layout'
import InfoCollapseArea from "@/components/elements/InfoCollapseArea.vue";
import Certificate from "@/modules/ulmerCertificatesApplicationForm/components/Certificate.vue";
import PersonalInformation from "@/modules/ulmerCertificatesApplicationForm/components/PersonalInformation.vue";
export default {
    name: "ApplicationForm",
    components: {
        PersonalInformation,
        Certificate,
        InfoCollapseArea,
        Layout,
    },
    data() {
        return {
            tabIndex: 0,
            name:null,
            formData:{
                name:null,
                surname:null
            },
        }
    },
    methods:{
      nextTab(event){
          this.tabIndex=event
      }
    },
    mounted() {
      const isLogin =this.$store.getters['UlmerCertificatesApplication/isLogin'];
      if (!isLogin){
          return this.$router.push('/certificates/application/login');
      }
      this.formData=isLogin
    },
}
</script>

<style scoped>
.hover-shadow:hover {
    box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important;
}
.transition {
    transition: all 0.3s ease;
}
</style>
